import React from 'react';
import PropTypes from 'prop-types';
import { Link, ButtonGroup, PrimaryButton } from '@common/components';
import { Button } from 'antd';
import { buildDialogUrl } from '@common/services';

export function FilledCancelledCtaButton({ application }) {
  if (application.state === 'accepted') {
    if (!application.acceptedOffer) return null;
    const assignmentId = application.acceptedOffer.staffingRequestAssignment.id;

    const offerConfirmationDrawerUrl = buildDialogUrl(
      'offer-confirmation-drawer',
      {
        props: {
          offerId: application.acceptedOffer.id,
        },
      }
    );

    return (
      <ButtonGroup>
        <Link to={`/works/supplier/team/${assignmentId}`}>
          <PrimaryButton>Assignment</PrimaryButton>
        </Link>
        <Link to={offerConfirmationDrawerUrl}>
          <Button>Offer</Button>
        </Link>
      </ButtonGroup>
    );
  }

  return null;
}

FilledCancelledCtaButton.propTypes = {
  application: PropTypes.shape({
    id: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    canWithdraw: PropTypes.object,
    acceptedOffer: PropTypes.object,
  }),
};
